module.exports = __webpack_public_path__ + "static/media/octorion-laptop.08ec8ffa.svg";